import script from "./OEditarPlanejamentoAtividade.vue?vue&type=script&setup=true&lang=ts"
export * from "./OEditarPlanejamentoAtividade.vue?vue&type=script&setup=true&lang=ts"

import "./OEditarPlanejamentoAtividade.vue?vue&type=style&index=0&id=21c5dac5&lang=scss"
import "./OEditarPlanejamentoAtividade.style.scss?vue&type=style&index=1&id=21c5dac5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21c5dac5"]])

export default __exports__